module.exports = __webpack_public_path__ + "static/media/division.5af34da5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/division.mp4
// module id = 60
// module chunks = 0